import { useBusinessContext } from '@root/context'
import { useTranslation } from 'react-i18next'
import { SettingsSubPageLayout } from '@pages/SettingsPage/components/SettingsSubPageLayout'
import TagSettingsLander from './TagSettingsLander'
import TagsDetails from './TagsDetails'

const TagSettings = () => {
  const [t] = useTranslation()

  const { data: business } = useBusinessContext()

  return (
    <SettingsSubPageLayout title={t('settings.tags.title')}>
      {!business?.has_tags ? <TagSettingsLander /> : <TagsDetails />}
    </SettingsSubPageLayout>
  )
}

export default TagSettings
